import styled from 'styled-components';

const ActionLink = styled.a`
  color: ${p => p.theme.colorPrimary};
  font-size: 12px;
  font-weight: 500;
  margin-left: 7px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export default ActionLink;



// WEBPACK FOOTER //
// ./src/components/text/ActionLink/index.js